module.exports = __webpack_public_path__ + "img/logo_sala.9c28a18d.png";